import { METHODS } from "../../config";
import { ENDPOINTS } from "../../config/endpoints";
import { fetchData } from "../../utils/fetchData";

export const getReplicatorsPage = async () => {
  const data = await fetchData(ENDPOINTS.GET.REPLICATORS_PAGE, {
    method: METHODS.GET,
  });
  return data;
};
